export default __webpack_public_path__ + "static/media/Armbands of the Savage Fang.9de39f72.jpg";